import { render, staticRenderFns } from "./LoadingRoutes.vue?vue&type=template&id=8ffc2e44"
import script from "./LoadingRoutes.vue?vue&type=script&lang=js"
export * from "./LoadingRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports